import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './core/permission'
import store from './store'
import * as filters from './core/filter'
import bootstrap from './core/bootstrap' 
import Print from 'vue-print-nb'
Vue.use(Print)
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
import VueClipboard from 'vue-clipboard2'
import { Modal } from 'ant-design-vue'
Vue.use(Modal)
Vue.use(VueClipboard)
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// 捕获导航被取消
const originalPush = router.push
router.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.config.productionTip = false

new Vue({
  router,
  store,
  created: bootstrap,
  render: h => h(App)
}).$mount('#app')
